import React, { useEffect, useRef, useState } from 'react';
import '../css/button.css';
import { Navigate } from 'react-router-dom';
import { set } from 'animejs';

const Nzakara = (props) => {
    const [musicPlaying1, setMusicPlaying1] = useState(false);
    const [musicPlaying2, setMusicPlaying2] = useState(false);
    const [musicPlaying3, setMusicPlaying3] = useState(false);
    const musicPlaying1Ref = useRef(musicPlaying1);
    const musicPlaying2Ref = useRef(musicPlaying2);
    const musicPlaying3Ref = useRef(musicPlaying3);
    const [step1, setStep1] = useState(0);
    const [step2, setStep2] = useState(0);
    const step1Ref = useRef(step1);
    const step2Ref = useRef(step2);

    const note1 = [2, 1, 0, 2, 1, 2, 1, 0, 0, 1, 1, 1, 1, 0, 2, 1, 0, 1, 0, 2, 1, 0, 0, 0, 0, 1, 1, 0, 2, 0];
    const note2 = [0, 1, 1, 0, 2, 0, 2, 1, 0, 2, 1, 2, 1, 0, 0, 1, 1, 1, 1, 0, 2, 1, 0, 1, 0, 2, 1, 0, 0, 0];

    const offset2 = 0.32 //dans l'animation sur la voix inf : au moment où l'image en zigzag revient au debut à
    //gauche, il faudrait introduire un petit retard de l'image de 32 centièmes de seconde

    const audio3keytimes = [ //temps pour l'audio 3 rouge et bleu en meme temps
        [0.00, 0.35, 0.70, 1.00, 1.35, 1.70, 2.00, 2.30, 2.70, 3.00, 3.30, 3.65, 3.95, 4.30, 4.65, 4.95, 5.30, 5.60, 5.90, 6.25, 6.55, 6.90, 7.20, 7.50, 7.85, 8.15, 8.50, 8.80, 9.10, 9.50],
        [9.80, 10.10, 10.45, 10.75, 11.05, 11.40, 11.70, 12.00, 12.35, 12.70, 13.00, 13.30, 13.60, 13.90, 14.25, 14.55, 14.85, 15.20, 15.50, 15.80, 16.10, 16.45, 16.80, 17.10, 17.40, 17.70, 18.05, 18.35, 18.65, 18.95],
        [19.25, 19.55, 19.85, 20.20, 20.50, 20.85, 21.15, 21.45, 21.75, 22.10, 22.40, 22.75, 23.05, 23.35, 23.65, 24.00, 24.30, 24.65, 24.95, 25.20, 25.60, 25.85, 26.20, 26.50, 26.80, 27.10, 27.45, 27.80, 28.00, 28.30],
        [28.65, 28.95, 29.25, 29.55, 29.90, 30.15, 30.50, 30.80, 31.15, 31.40, 31.75, 32.05, 32.35, 32.70, 33.00, 33.30, 33.60, 33.95, 34.25, 34.55, 34.90, 35.15, 35.50, 35.80, 36.10, 36.40, 36.75],
    ];

    const offset = 0.20 // dans l'animation des 2 voix : il faudrait retarder l'image sur le son d'environ 20
    // centièmes de secondes

    const [audio1,] = useState(new Audio(process.env.PUBLIC_URL + '/assets/sounds/harp1.mp3'));
    const [audio2,] = useState(new Audio(process.env.PUBLIC_URL + '/assets/sounds/harp2.mp3'));
    const [audio3,] = useState(new Audio(process.env.PUBLIC_URL + '/assets/sounds/harp3.mp3'));

    const tempo = 0.35;

    const playMusic1 = () => {
        //reset 2
        audio2.currentTime = 0;
        setStep2(0);
        step2Ref.current = 0;
        pauseMusic2();
        //play 1
        audio1.currentTime = 0;
        audio1.play();
        setMusicPlaying1(true);
        musicPlaying1Ref.current = true;
    };

    const pauseMusic1 = () => {
        audio1.pause();
        setMusicPlaying1(false);
        musicPlaying1Ref.current = false;
    };

    const playMusic2 = () => {
        //reset 1
        audio1.currentTime = 0;
        setStep1(0);
        step1Ref.current = 0;
        pauseMusic1();
        //play 2
        audio2.currentTime = 0;
        audio2.play();
        setMusicPlaying2(true);
        musicPlaying2Ref.current = true;
    };

    const pauseMusic2 = () => {
        audio2.pause();
        setMusicPlaying2(false);
        musicPlaying2Ref.current = false;
    };

    const playMusic3 = () => {
        audio3.currentTime = 0;
        audio1.currentTime = 0;
        audio2.currentTime = 0;
        audio3.play();
        setMusicPlaying3(true);
        musicPlaying3Ref.current = true;
    };

    const pauseMusic3 = () => {
        audio3.pause();
        setMusicPlaying3(false);
        musicPlaying3Ref.current = false;
    };

    const pauseMusic = () => {
        pauseMusic1();
        pauseMusic2();
        pauseMusic3();
    };

    const getStepAudio3 = (t) => {
        for (let i = 0; i < audio3keytimes.length; i++) {
            for (let j = 0; j < audio3keytimes[i].length; j++) {
                if (audio3keytimes[i][j] + offset >= t) {
                    return [i, j];
                }
            }
        }
        // If no time is found, return a value indicating not found
        return [-1, -1];
    }

    const segments1 = [];
    for (let i = 1; i < Math.min(step1Ref.current + 1, note1.length); i++) {
        const x1 = (i - 1) * 11.18;
        const y1 = 5 + note1[i - 1] * 10;
        const x2 = x1 + 12;
        const y2 = 5 + note1[i] * 10;
        const line = (
            <line
                key={i}
                x1={x1}
                y1={y1}
                x2={x2}
                y2={y2}
                style={{ stroke: 'blue', strokeWidth: '3px', zIndex: 4 }}
            />
        );
        segments1.push(line);
    }

    const segments2 = [];
    for (let i = 1; i < Math.min(step2Ref.current, 23) + 1; i++) {
        const x1 = (i + 5) * 11.18;
        const y1 = 5 + note2[Math.min(i + 5, note2.length - 1)] * 10;
        const x2 = x1 + 12;
        const y2 = 5 + note2[Math.min(i + 6, note2.length - 1)] * 10;
        const line = (
            <line
                key={i}
                x1={x1}
                y1={y1}
                x2={x2}
                y2={y2}
                style={{ stroke: 'red', strokeWidth: '3px', zIndex: 4 }}
            />
        );
        segments2.push(line);
    }

    for (let i = 24; i < step2Ref.current + 1; i++) {
        const x1 = (i - 24) * 11.18;
        const y1 = 5 + note2[Math.min(i - 24, note2.length - 1)] * 10;
        const x2 = x1 + 12;
        const y2 = 5 + note2[Math.min(i - 23, note2.length - 1)] * 10;
        const line = (
            <line
                key={i}
                x1={x1}
                y1={y1}
                x2={x2}
                y2={y2}
                style={{ stroke: 'red', strokeWidth: '3px', zIndex: 4 }}
            />
        );
        segments2.push(line);
    }

    function clearAll() {
        // Get a reference to the last interval + 1
        const interval_id = window.setInterval(function () { }, Number.MAX_SAFE_INTEGER);

        // Clear any timeout/interval up to that id
        for (let i = 1; i < interval_id; i++) {
            window.clearInterval(i);
        }

        props.audio.forEach(audio => audio.pause());
    }

    useEffect(() => {
        clearAll();
        props.audio.push(audio1);
        props.audio.push(audio2);
        props.audio.push(audio3);

        setInterval(() => {
            // audio 1
            if (musicPlaying1Ref.current) {
                if (audio1.currentTime > audio1.duration) {
                    pauseMusic1();
                }
                if (audio1.currentTime == 0) {
                    setStep1(0);
                    step1Ref.current = 0;
                } else {
                    step1Ref.current = Math.floor(audio1.currentTime / tempo);
                    setStep1(step1Ref.current);
                }
            }

            if (musicPlaying2Ref.current) {
                if (audio2.currentTime > 10.35) {
                    pauseMusic2();
                }
                if (audio2.currentTime == 0) {
                    setStep2(0);
                    step2Ref.current = 0;
                } else {
                    if (audio2.currentTime <= tempo * 24) {
                        step2Ref.current = Math.floor(audio2.currentTime / tempo);
                    } else { // offset sur le retour à gauche
                        step2Ref.current = Math.floor(audio2.currentTime / tempo + offset);
                    }
                    setStep2(step2Ref.current);
                }
            }

            if (musicPlaying3Ref.current) {
                if (audio3.currentTime > 37.1) {
                    pauseMusic3();
                }
                if (audio3.currentTime == 0) {
                    setStep1(0);
                    setStep2(0);
                    step1Ref.current = 0;
                    step2Ref.current = 0;
                } else {
                    let [page, step] = getStepAudio3(audio3.currentTime);
                    setStep1(step);
                    step1Ref.current = step;
                    if (step >= 6) {
                        setStep2(step - 6);
                        step2Ref.current = step - 6;
                    }
                    else {
                        setStep2(0);
                        step2Ref.current = 0;
                    }
                }
            }
        }, 40);
    }, []);

    return (
        <>
            <div
                className='background'
                style={{
                    backgroundColor: '#ff802d',
                }}
            />
            <div className="anim" style={{ position: 'absolute', top: '50px', left: '50px' }}>
                <img
                    src={process.env.PUBLIC_URL + '/assets/images/nzakara/Points2.png'}
                    style={{
                        position: 'absolute',
                        top: '149px',
                        left: '86px',
                        zIndex: 5
                    }}
                    alt="anim"
                />
                <img
                    src={process.env.PUBLIC_URL + '/assets/images/nzakara/harpe.png'}
                    style={{
                        position: 'absolute',
                        left: '20px',
                        top: '100px',
                        zIndex: 3
                    }}
                    alt="anim"
                />
                <svg
                    style={{
                        position: 'absolute',
                        top: '149px',
                        left: '89px',
                        zIndex: 4,
                    }}
                    height="80"
                    width="350"
                >
                    {segments1}
                </svg>
                {/*<p
                    style={{
                        position: 'absolute',
                        top: '50px',
                        left: '89px',
                        zIndex: 4,
                        color: 'white',
                        fontSize: '20px',
                    }}
                >{step1Ref.current}
                </p>*/}
                <svg
                    style={{
                        position: 'absolute',
                        top: '170px',
                        left: '89px',
                        zIndex: 4,
                    }}
                    height="80"
                    width="350"
                >
                    {segments2}
                </svg>
            </div>
            <img
                src={process.env.PUBLIC_URL + "/assets/images/nzakara/bt1.png"}
                alt="play"
                onClick={playMusic1}
                style={{ position: 'absolute', left: '125px', top: '116px', width: '30px', zIndex: 3 }}
                onMouseOver={(e) => e.currentTarget.src = process.env.PUBLIC_URL + "/assets/images/nzakara/bt1-1.png"}
                onMouseOut={(e) => e.currentTarget.src = process.env.PUBLIC_URL + "/assets/images/nzakara/bt1.png"}
            />

            <img
                src={process.env.PUBLIC_URL + "/assets/images/nzakara/bt1.png"}
                alt="play"
                onClick={playMusic2}
                style={{ position: 'absolute', left: '198px', top: '316px', width: '30px', zIndex: 3 }}
                onMouseOver={(e) => e.currentTarget.src = process.env.PUBLIC_URL + "/assets/images/nzakara/bt1-1.png"}
                onMouseOut={(e) => e.currentTarget.src = process.env.PUBLIC_URL + "/assets/images/nzakara/bt1.png"}
            />

            <img
                src={process.env.PUBLIC_URL + "/assets/images/nzakara/bt3.png"}
                alt="pause"
                onClick={playMusic3}
                style={{ position: 'absolute', left: '498px', top: '210px', width: '30px', zIndex: 3 }}
                onMouseOver={(e) => e.currentTarget.src = process.env.PUBLIC_URL + "/assets/images/nzakara/bt3-1.png"}
                onMouseOut={(e) => e.currentTarget.src = process.env.PUBLIC_URL + "/assets/images/nzakara/bt3.png"}
            />

            <img
                src={process.env.PUBLIC_URL + "/assets/images/nzakara/bt2.png"}
                alt="pause"
                onClick={pauseMusic}
                style={{ position: 'absolute', left: '537px', top: '210px', width: '30px', zIndex: 3 }}
                onMouseOver={(e) => e.currentTarget.src = process.env.PUBLIC_URL + "/assets/images/nzakara/bt2-1.png"}
                onMouseOut={(e) => e.currentTarget.src = process.env.PUBLIC_URL + "/assets/images/nzakara/bt2.png"}
            />
        </>
    );
}

export default Nzakara;